// extracted by mini-css-extract-plugin
module.exports = {"list":"Breadcrumbs--list--3_ZIU","item":"Breadcrumbs--item--1A7Sa"};